import API from "../../../../../global/api";
// import _ from "lodash";
import jsPDF from "jspdf";
import moment from "moment";
import { PDFHeader } from "../../../../../global/globalFunctions";


export const requestSearchAccountLedger = () => {
    return {
        type: "REQUEST_SEARCH_LEDGER",
    };
};
export const successSearchAccountLedger = (data) => {
    return {
        type: "SUCCESS_SEARCH_LEDGER",
        payload: data,
    };
};
export const errorSearchAccountLedger = () => {
    return {
        type: "ERROR_SEARCH_LEDGER",
    };
};
export const SearchAccountLedgerApi = (data, startDate, endDate, accountName) => {
    return (dispatch) => {
        dispatch(requestSearchAccountLedger());
        API.post(`/levelFour/account_ledger`, data).then((res) => {
            let getData = res.data;
            dispatch(successSearchAccountLedger(getData));
        }).catch((error) => {
            dispatch(errorSearchAccountLedger());
        });
    };
};



export const requestSearchAccountLedgerPDF = () => {
    return {
        type: "REQUEST_SEARCH_LEDGER_PDF",
    };
};
export const successSearchAccountLedgerPDF = (data) => {
    return {
        type: "SUCCESS_SEARCH_LEDGER_PDF",
        payload: data,
    };
};
export const errorSearchAccountLedgerPDF = () => {
    return {
        type: "ERROR_SEARCH_LEDGER_PDF",
    };
};
export const AccountLedgerPDFApi = (data, startDate, endDate, levelFourName) => {
    return async (dispatch) => {
        try {
            dispatch(requestSearchAccountLedgerPDF());

            const { data: resData } = await API.post(`/levelFour/account_ledger_pdf`, data);
            if (!resData || !Array.isArray(resData.data)) throw new Error("Invalid response data");

            const {
                debitSum = 0,
                creditSum = 0,
                data: ledgerData = []
            } = resData;

            const doc = new jsPDF("landscape", "pt", "A4");
            PDFHeader(doc, "Account Ledger");

            const marginLeft = 40;

            // --- Utility functions ---
            const formatAmount = (val) => val ? `${Number(val).toLocaleString()}/-` : "";
            const formatAmount2 = (val) => `${Number(val).toLocaleString()}/-`;
            const getSafe = (arr, idx, key) => arr[idx]?.[key] ?? 0;

            // --- Summary data ---
            const openingBalance = `Opening Balance: ${formatAmount(getSafe(ledgerData, 0, "closingBalance"))}`;
            // const totalDebit = `Total Debit: ${formatAmount(debitSum)}`;
            // const totalCredit = `Total Credit: ${formatAmount(creditSum)}`;
            const lastIndex = ledgerData.length - 1;
            const closingBalanceValue = getSafe(ledgerData, lastIndex, "closingBalance");
            const closingSign = getSafe(ledgerData, lastIndex, "closingBalanceSign") || "";
            const closingBalance = `Closing Balance: ${formatAmount(closingBalanceValue)} ${closingSign}`;
            const dateRange = `Date From: ${data.startDate} - Date To: ${data.endDate}`;
            const accountName = `Account Name: ${levelFourName || ''}`;

            // --- PDF Text ---
            doc.setFont("Times New Roman", "Normal");
            doc.setFontSize(11);

            const textLines = [accountName, dateRange, openingBalance, closingBalance,];
            textLines.forEach((line, i) => doc.text(line, marginLeft, 120 + i * 15));

            // --- Table data ---
            const headers = [[
                "Date", "Voucher ID", "Description", "Bill",
                "Cheque No", "Cheque Date", "Debit", "Credit",
                "Closing Balance", "Type",
            ]];

            const tableBody = ledgerData.map((x) => [
                x.voucherDate || "",
                x.vocManualNumber || "",
                x.voucherDescription || "",
                x.billNumber || "",
                x.chequeNo || "",
                x.chequeDate || "",
                formatAmount(x.debit),
                formatAmount(x.credit),
                formatAmount2(x.closingBalance),
                x.closingBalanceSign || "",
            ]);

            const totalsRow = [
                "",
                "",
                { content: "TOTAL", colSpan: 1, styles: { halign: "left", fontStyle: "bold" } },
                "",
                "",
                "",
                { content: debitSum, styles: { halign: "left", fontStyle: "bold" } },
                { content: creditSum, styles: { halign: "left", fontStyle: "bold" } },
            ];
            tableBody.push(totalsRow);

            // --- Render table ---
            doc.autoTable({
                startY: 180,
                startX: 3,
                head: headers,
                body: tableBody,
                theme: "grid",
                styles: { fontSize: 9 },
            });

            // --- Final PDF properties ---
            doc.setProperties({ title: `Account Ledger ${moment().format("YYYY-MM-DD")}` });
            doc.output("dataurlnewwindow");

            dispatch(successSearchAccountLedgerPDF(resData));
        } catch (error) {
            console.error("AccountLedgerPDFApi error:", error);
            dispatch(errorSearchAccountLedgerPDF());
        }
    };
};